import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // También puedes registrar el error en un servicio de reporte de errores
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Puedes renderizar cualquier interfaz de repuesto
            return (
                <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
                    <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center border border-slate-100 animate-in fade-in zoom-in duration-300">
                        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <AlertTriangle className="text-red-600 w-10 h-10" />
                        </div>
                        <h1 className="text-2xl font-black text-slate-900 mb-2">¡Algo salió mal!</h1>
                        <p className="text-slate-600 mb-8">
                            Lo sentimos, ha ocurrido un error inesperado al cargar esta sección.
                            Nuestros ingenieros han sido notificados.
                        </p>

                        <div className="flex flex-col gap-3">
                            <Button
                                onClick={() => window.location.reload()}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold h-12 rounded-xl"
                            >
                                <RefreshCw className="mr-2 h-4 w-4" /> Recargar Página
                            </Button>
                            <Button
                                variant="outline"
                                onClick={() => window.location.href = '/'}
                                className="w-full border-slate-200 text-slate-600 font-bold h-12 rounded-xl"
                            >
                                <Home className="mr-2 h-4 w-4" /> Volver al Inicio
                            </Button>
                        </div>

                        {process.env.NODE_ENV === 'development' && (
                            <div className="mt-8 text-left">
                                <p className="text-xs font-mono text-red-500 bg-red-50 p-4 rounded-lg overflow-auto max-h-40">
                                    {this.state.error && this.state.error.toString()}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
